/*
 *		Copyright (c) 2011-2016 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .directive('accFileDownloadPage', [function () {
        return {
            link: function ($scope, elem, attrs) {
                if (attrs['node']) {
                    $scope.node = angular.fromJson(attrs['node']);
                    elem.removeAttr('node');
                }

                if (!attrs['singleUseLink'])
                    return;

                $scope.downloadedAlready = false;

                if (attrs['singleUseLink'] === 'true') {
                    elem.find('.download').on('click', function (e) {
                        if ($scope.downloadedAlready) {
                            e.preventDefault();
                        } else {
                            $scope.$apply(function () {
                                $scope.downloadedAlready = true;
                            });
                        }
                    });
                }
            }
        }
    }]);
